export default "__VITE_ASSET__a3T0Bthx__"